import { useEffect, useState } from 'react';

export const useDebounce = <T>(value: T, delay = 500): T => {
	const [debounced, setDebounced] = useState(value);

	useEffect(() => {
		const handleDebounce = setTimeout(() => setDebounced(value), delay);
		return () => clearTimeout(handleDebounce);
	}, [value, delay]);

	return debounced;
};
